import React, { useCallback } from "react";

import Hamburger from "./Hamburger";
import HelpfulLinks from "./HelpfulLinks";
import Icon from "@components/Icon";
import T, { GetLang } from "@components/translations/Translations";

import { GUARDIAN_DASHBOARD } from "@utils/auth/config";

import "@/styles/Header.scss";

interface WelcomeHeaderProps {
    isOE?: boolean;
}

/**
 * This is returning the header content with buttons and links
 * @name WelcomeHeader
 * @return {JSX.Element}
 */
const WelcomeHeader = ({ isOE = false }: WelcomeHeaderProps): React.JSX.Element => {
    const lang = GetLang();

    const handleNavigate = useCallback((url: string): void => {
        globalThis.location.assign(url);
    }, []);

    const handleFaqClick = useCallback((): void => {
        handleNavigate("https://www.dcsdk12.org/about/departments/choice-programming/open-enrollment");
    }, [handleNavigate]);

    const handleDashboardClick = useCallback((): void => {
        globalThis.location.assign(GUARDIAN_DASHBOARD);
    }, []);

    return (
        <nav className="header-container">
            <div className="header-left">
                <div>
                    <a
                        aria-label="EngagED Parent Portal Page Link"
                        href={GUARDIAN_DASHBOARD}
                        onClick={() => {
                            sessionStorage.clear();
                            return true;
                        }}
                        rel="noopener noreferrer"
                        style={{
                            textDecoration: "none",
                            color: "black"
                        }}
                        target="_self"
                        tabIndex={0}
                    >
                        <Icon
                            style={{ marginTop: "15px" }}
                            fill="#19608f"
                            height={120}
                            iconName="DOUGLAS_COUNTY_SCHOOL_DISTRICT"
                            width={120}
                        />
                    </a>
                </div>
                <div className="header-name-container">
                    <h5 className="header-name">
                        {T({ tKey: isOE ? "OEApp_Header" : "Welcome_Header_Alt", langStr: lang })}
                    </h5>
                </div>
            </div>
            <div className="header-right">
                <div className="nav-button-container">
                    <HelpfulLinks />
                    <button
                        aria-label="FAQ Button"
                        className="btn btn-primary m-2 color-override"
                        onClick={handleFaqClick}
                        type="button"
                    >
                        <span className="nav-button-text">
                            {T({ tKey: "Global_Faq", langStr: lang })}
                            <i className="bi bi-person-raised-hand" style={{ marginLeft: "5px" }} />
                        </span>
                    </button>
                    <button
                        aria-label="Dashboard Button"
                        className="btn btn-primary m-2 color-override"
                        onClick={handleDashboardClick}
                        type="button"
                    >
                        <span className="nav-button-text">
                            {T({ tKey: "Global_Dashboard", langStr: lang })}
                            <i className="bi bi-house" style={{ marginLeft: "5px" }} />
                        </span>
                    </button>
                </div>
                <div className="mobile-hamburger">
                    <Hamburger />
                </div>
            </div>
        </nav>
    );
};

export default WelcomeHeader;
